module.exports = __webpack_public_path__ + "static/img/culture-vision.9a8610e5.png";